import React from "react";
import Spacing from "../Spacing";
import HeroStyle2 from "../Hero/HeroStyle2";
import Brands from "../Brands";
import Marquee from "../Marquee";
import Cta from "../Cta";
import SectionHeading from "../SectionHeading";
import Accordion from "../Accordion";
import PostCarousel from "../Slider/PostCarousel";
import TestimonialSlider from "../Slider/TestimonialSlider";
import Award from "../Award";
import VideoModal from "../VideoModal";
import ServiceSlider from "../Slider/ServiceSlider";
import AboutStyle2 from "../About/AboutStyle2";
import FunFact from "../FunFact";
import Button from "../Button";
import CaseStudy from "../CaseStudy";
import { pageTitle } from "../../helpers/PageTitle";
import ContactPage from "./ContactPage";
import ModalServices from "./ModalServices";
import ModalBlogs from "./ModalBlogs";







const servideData = [
  {
    iconSrc: "/images/marketing-agency/service_icon_1.svg",
    title: "Data Management",
    subTitle:
      "Unlock your eCommerce potential with our expert management services for accounts, inventory, orders, listings, and marketplaces like Amazon, eBay, and more.",
    btnText: "See More",
    btnUrl: "/",
    idName:"#modalDM"
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_3.svg",
    title: "Sponsored Ads",
    subTitle:
      "Maximize eCommerce sales with our PPC services. Our experts create targeted campaigns to boost visibility, traffic, and sales on top marketplaces.",
    btnText: "See More",
    btnUrl: "/",
     idName:"#modalSA"
  },
  {
    iconSrc: "/images/marketing-agency/service_icon_4.svg",
    title: "Digital Marketing",
    subTitle:
      "At Fleek Commerce, we offer SEO, SEM, Google Shopping, email, and social media marketing to drive traffic and convert visitors into customers.",
    btnText: "See More",
    btnUrl: "/",
     idName:"#modalDMar"
  },
  {
    iconSrc: "/images/marketing-agency/website-development.png",
    title: "Website Development",
    subTitle:
      "At Fleek Commerce, we deliver affordable eCommerce solutions with Shopify, Magento, and WooCommerce for businesses of all sizes globally.",
    btnText: "See More",
    btnUrl: "/",
     idName:"#modalWD"
  },
  {
    iconSrc: "/images/marketing-agency/creative-design.png",
    title: "Creative Graphics",
    subTitle:
      "Fleek Commerce offers creative graphic design, from logos and SMM banners to brand stores and A+ content, to make your brand stand out.",
    btnText: "See More",
    btnUrl: "/",
     idName:"#modalCG"
  },
  {
    iconSrc: "/images/marketing-agency/customer-support.png",
    title: "Customer Support",
    subTitle:
      "We provide marketplace and social media support, inbound sales management, inventory replenishment, and detailed order reporting.",
    btnText: "See More",
    btnUrl: "/",
     idName:"#modalCS"
  }
];
const funfactData = [
  { title: "Happy Customers", number: "150+" },
  { title: "Work’s Completed", number: "300+" },
  { title: "Skilled Team Members", number: "30" },
  { title: "Most Valuable Awards", number: "3" }
];
const awardData = [
  {
    brand: "Behance",
    title: "UI/UX design of the month",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "December 12, 2023",
    awardImgUrl: "/images/creative-agency/award-img-6.png"
  },
  {
    brand: "Awwwards",
    title: "CSS awards design",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "January 05, 2022",
    awardImgUrl: "/images/creative-agency/award-img-5.png"
  },
  {
    brand: "Google",
    title: "Website of the day",
    subTitle:
      "Accusamus et iusto odio dignissimos ducimus qui blanditiis fedarals praesentium voluptatum deleniti atque corrupti quos dolores",
    date: "March 20, 2021",
    awardImgUrl: "/images/creative-agency/award-img-4.png"
  }
];
const testimonialData = [
  {
    text: "Working with Fleek Commerce for over a year has been a pleasure. Their proactive, responsive, and knowledgeable team exceeds our expectations.",
    avatarName: "Cary Anderson",
    avatarDesignation: "USA"
  },
  {
    text: "The professionalism of Fleek Commerce stands out. They cover listing optimization, design, and web creation, always delivering timely results.",
    avatarName: "Jhon Gate",
    avatarDesignation: "USA"
  },
  {
    text: "Working with Fleek Commerce for 18 months was a pleasure. Their skilled team helped us achieve 150% revenue growth with optimized SKUs and ads.",
    avatarName: "Erfan Samei",
    avatarDesignation: "CA"
  }
];
const caseStudyData = [
  {
    thumbnailSrc: "/images/marketing-agency/case_study_1.jpeg",
    title: "Digital marketing management",
    category: "Marketing",
    number: "01",
    href: "/case-study-details"
  },
  {
    thumbnailSrc: "/images/marketing-agency/case_study_2.jpeg",
    title: "Digital marketing management",
    category: "Marketing",
    number: "02",
    href: "/case-study-details"
  },
  {
    thumbnailSrc: "/images/marketing-agency/case_study_3.jpeg",
    title: "Digital marketing management",
    category: "Marketing",
    number: "03",
    href: "/case-study-details"
  },
  {
    thumbnailSrc: "/images/marketing-agency/case_study_4.jpeg",
    title: "Digital marketing management",
    category: "Marketing",
    number: "04",
    href: "/case-study-details"
  }
];
const postData = [
  {
    thumbnailSrc: "/images/creative-agency/amazon_fba.png",
    title: "What Will 2025 Be Like for Amazon FBA Sellers?",
    date: "November 30, 2024",
    url: "/",
    idModal:"#modalBlog1"
  },
  {
    thumbnailSrc: "/images/creative-agency/amazon_haul.png",
    title: "Amazon Haul: A new storefront with ‘Crazy Low’ Prices",
    date: "November 26, 2024",
    url: "/",
      idModal:"#modalBlog2"
  },
  {
    thumbnailSrc: "/images/creative-agency/keyword_research.png",
    title: "How to Do Keyword Research for eBay: 3 Free Easy Ways",
    date: "November 20, 2024",
    url: "/",
      idModal:"#modalBlog3"
  },
  {
    thumbnailSrc: "/images/creative-agency/amazon-holiday.png",
    title:
      "Top 5 Winning Amazon PPC Strategies for Black Friday & Cyber Monday 2024!",
    date: "November 16, 2024",
    url: "/",
      idModal:"#modalBlog4"
  },
  // {
  //   thumbnailSrc: "/images/creative-agency/Amazon-Product-Variations.png",
  //   title: "Amazon Product Variations: How It Can Boost Rankings and Sales",
  //   date: " November 15, 2024",
  //   url: "/",
  //     idModal:"#modalBlog5"
  // },
  // {
  //   thumbnailSrc: "/images/creative-agency/Amazon-Vendor-to-Seller.png",
  //   title:
  //     "Amazon Vendor to Seller Central: Maximize Profits with a Strategic Switch",
  //   date: " November 11, 2024",
  //   url: "/",
  //     idModal:"#modalBlog6"
  // },
  // {
  //   thumbnailSrc:
  //     "/images/creative-agency/Efficient-Order-Fulfillment-in-Shopify.png",
  //   title: "Efficient Order Fulfillment in Shopify From Packaging to Shipping",
  //   date: "November 8, 2024",
  //   url: "/",
  //     idModal:"#modalBlog7"
  // },
  // {
  //   thumbnailSrc: "/images/creative-agency/How-to-List-Multiple-Products.png",
  //   title: "How to List Multiple Products on eBay in Bulk",
  //   date: "November 3, 2024",
  //   url: "/",
  //     idModal:"#modalBlog8"
  // }
];
const faqData = [
  {
    title: "01. What types of data management services do you offer?",
    content:
      "Unlock the full potential of your ecommerce business with our expert data management services. We offer a comprehensive range of services to help you manage your accounts, inventory, orders, listings, and marketplaces on platforms such as Amazon, eBay, Walmart, Shopify, Magento, and more. We have extensive experience in managing multi-channel software like Linnworks, channelAdvisor, Sellbrite, and others. We also offer virtual assistant services to help you with social media handling, promotional offer management, competitor analysis, product sourcing, research, and more. Let us help you optimize your ecommerce business and achieve your goals!"
  },
  {
    title:
      "02. How do you help businesses with sponsored ads and digital marketing?",
    content:
      "Maximize your ecommerce sales with our comprehensive PPC and Sponsored Ad services. Our expert in-house team creates and executes targeted advertising campaigns on popular marketplaces like Amazon, eBay, Walmart, and more. We've helped thousands of businesses achieve their goals by increasing visibility, driving traffic, and boosting sales. With our data-driven insights and strategic approach, we optimize your campaigns to maximize ROI. Whether you need Amazon PPC, AdWords optimization and management, Bing Ads management, App marketing, or PPC audits, we've got you covered. Let us take your ecommerce business to the next level and experience the difference that our PPC marketing service can make. Partner with us today and watch your business grow."
  },
  {
    title: "03. How does your digital marketing service help businesses grow?",
    content:
      "We believe that digital marketing is not just about driving traffic to your website, but also about converting those visitors into loyal customers. That's why we offer a comprehensive suite of digital marketing services to help you grow your online business. Our services include SEO and SEM, blog creation, Google Shopping, Google Analytics, Email Marketing, Social Media Marketing, and more. From creating effective ad campaigns to optimizing your website for search engines, we have the expertise and experience to help you achieve your marketing goals. So if you're ready to take your online business to the next level, get in touch with us today. Let us help you develop a customized digital marketing strategy that's tailored to your unique business needs. Contact us now and let's start growing your online business together!"
  },
  {
    title: "04. What makes your website development services unique?",
    content:
      "We strive for perfection in every aspect of our web design to ensure that it aligns with your business strategy. Our team analyzes, integrates, and processes your vision to produce the best results. Because we know that in the dynamic world of digital commerce, attracting, engaging, and retaining customers is critical. At Fleek Commerce, we make it simple for you to get started with powerful ecommerce solutions using Shopify, Magento, WooCommerce, and many more. Our skilled team of ecommerce web store developers has completed projects for everyone from small to large businesses. Our affordable pricing has attracted lots of small and medium businesses around the world."
  },
  {
    title: "05. What is the Ebay Template Generator, and how does it work?",
    content:
      "Our eBay Template Generator helps sellers create professional and visually appealing product templates. This tool ensures your listings stand out, increasing customer engagement and boosting sales."
  }
];
const brandList = [
  {
    logoSrc: "/images/marketing-agency/brand_1.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_2.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_3.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_4.svg",
    logoAlt: "Brand"
  }
];
const brandListDark = [
  {
    logoSrc: "/images/marketing-agency/brand_1_dark.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_2_dark.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_3_dark.svg",
    logoAlt: "Brand"
  },
  {
    logoSrc: "/images/marketing-agency/brand_4_dark.svg",
    logoAlt: "Brand"
  }
];

export default function MarketingAgencyPage({ darkMode }) {
  pageTitle("Marketing Agency");
  return (
    <>
      <HeroStyle2
        miniTitle="London Based Marketing Agency"
        title="Unlock Your Business's Potential with Expert Digital Marketing Solutions"
        subTitle="Our agency offers a comprehensive suite of lots services, including Branding, Advertising, Social marketing, Video making, and Marketing analysis."
        mikeIcon={
          darkMode ? "/images/icons/mike_dark.svg" : "/images/icons/mike.svg"
        }
      />

      {/* <Spacing lg="135" md="70" /> */}
      <Marquee text="We provide services - Data Management - Multichannerl Softwares - Sponsored Ads - Digital Marketing - Website Development - Creative Graphics - Customer Support - Ebay Template Generator" />
      <Spacing lg="84" md="50" />
      <div className="container">
        <Brands data={darkMode ? brandListDark : brandList} />
      </div>
      {/* <Spacing lg="135" md="80" /> */}

      <section id="about-us" className="">
        <div className="cs_height_150 cs_height_lg_75" />
        <AboutStyle2
          thumbnailSrc1="/others-image/about_img_1.png"
          thumbnailSrc2="/others-image/about_img_2.png"
          uperTitle="Who We Are"
          title="Full-stack creatives and designing agency"
          subTitle="At Fleek Commerce, with our 2+ years of expertise, we understand this and we are dedicated to accepting this challenge of empowering your business to unlock your full online potential, driving revenue growth, and delivering exceptional customer experiences in the ever-expanding digital marketplace. With Fleek Commerce, you can transfer all these tasks to our expert managers and save the time you need so you can focus on the things that matter to grow your business."
          featureList={[
            "3X Faster Solution",
            "Boost Seller Acquisition",
            "Minimize Downtime",
            "24/7 Support"
          ]}
          btnText="Let's Connect"
          btnUrl="/"
        />
      </section>

      <div className="container">
        <Spacing lg="125" md="70" />
        <FunFact data={funfactData} />
      </div>

      <section className="cs_p76_full_width" id="services">
        <Spacing lg="143" md="75" />
        <SectionHeading title="Services we provide" subTitle="Our Services" />
        <Spacing lg="85" md="45" />
        <ServiceSlider data={servideData} />
      </section>

      {/* <section>
        <Spacing lg="118" md="70" />
        <div className="container">
          <SectionHeading
            title="Real world solutions successful <br />case studies in Zivan"
            subTitle="Case Study"
          />
          <Spacing lg="85" md="45" />
        </div>


        <CaseStudy data={caseStudyData} />



        <Spacing lg="100" md="60" />
        <div className="container">
          <div className="text-center">
            <Button btnText="More Case Study" btnUrl="/" />
          </div>
        </div>
      </section> */}

      <div className="container">
        <Spacing lg="126" md="70" />
        <VideoModal
          videoSrc="https://www.youtube.com/embed/VcaAVWtP48A"
          bgUrl="/images/marketing-agency/videoThumb3.png"
          title="Grow Your eCommerce Online Business with Fleek Commerce Services"
        />
      </div>
      <TestimonialSlider
        layeredImages={[
          "/images/marketing-agency/amazon.jpg",
          "/images/marketing-agency/eBay.png",
          "/images/marketing-agency/walmart.png",
          "/images/marketing-agency/etsy.png",
          "/images/marketing-agency/shopify.png"
        ]}
        data={testimonialData}
      />

      {/* 
      <section className="cs_primary_bg cs_shape_animation_2">
        <Spacing lg="143" md="75" />
        <div className="cs_shape_1 position-absolute">
          <svg
            width={65}
            height={64}
            viewBox="0 0 65 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.5">
              <path
                d="M62.4554 25.9314C55.6838 19.6081 40.1618 12.4752 32.1637 20.1537C41.7609 21.9206 53.2379 29.2392 48.3751 39.1677C45.1712 45.7019 38.7353 45.7177 33.3337 41.995C27.338 37.8739 25.7108 31.2667 27.4596 24.5962C26.5312 24.5866 25.6039 24.6605 24.6889 24.8172C9.80991 27.7447 14.0713 47.6353 20.9187 55.948C22.4528 57.8045 19.7488 60.3159 18.1393 58.4837C7.86403 46.8126 6.49349 23.0691 25.5532 19.9295C26.8892 19.7254 28.2446 19.6801 29.5912 19.7945C36.9845 9.42053 56.5698 17.4866 64.055 24.4366C65.1096 25.4175 63.4831 26.8926 62.4554 25.9314ZM33.9938 39.0327C38.3927 42.4636 44.2429 40.8527 44.3919 34.8698C44.6036 28.2263 35.7464 25.0921 29.1457 24.655C27.1454 29.9313 29.4427 35.4836 33.9938 39.0327Z"
                fill="#4F4747"
              />
            </g>
          </svg>
        </div>
        <div className="container">
          <SectionHeading
            title="Our prize achievement"
            subTitle="Awards"
            variantColor="cs_white_color"
          />
          <Spacing lg="85" md="45" />
          <Award data={awardData} />
        </div>
        <Spacing lg="150" md="80" />
      </section> */}

      <section style={{ marginTop: "1rem" }}>
        <div className="container">
          <Cta
            title="Is there a specific project or goal that you have in mind?"
            btnText="Contact Us"
            btnUrl="/contact"
            bgUrl="/images/creative-agency/cta_bg.jpeg"
          />
        </div>
      </section>

      <section className="cs_p76_full_width" id="blog">
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Some recent news" subTitle="Our Blog" />
          <Spacing lg="85" md="45" />
        </div>
        <PostCarousel data={postData} />
      </section>

      <section>
        <Spacing lg="143" md="75" />
        <div className="container">
          <SectionHeading title="Frequently asked question" subTitle="FAQs" />
          <Spacing lg="55" md="30" />
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <Accordion variant="cs_type_1" data={faqData} />
            </div>
          </div>
        </div>
        {/* <Spacing lg="120" md="60" /> */}
      </section>

      <section id="contact">
        <ContactPage />
      </section>

      {/* <Spacing lg="135" md="70" />
      <Marquee text="We Create Design - Build App - Website - Branding - SEO" />
      <Spacing lg="84" md="50" />
      <div className="container">
        <Brands data={darkMode ? brandListDark : brandList} />
      </div> */}
      {/* <Spacing lg="135" md="80" /> */}

  <section>
    <ModalServices/>
  </section>

  <section>
    <ModalBlogs/>
  </section>
    </>
  );
}
